export default __webpack_public_path__ + "static/media/typeCube.5cf4a01b.PNG";